module.exports = __webpack_public_path__ + "img/212.6d4f8307.jpg";